import React from "react";
import ReactMarkdown from "react-markdown";

import {
  BodyContainer,
  HeaderSectionEntriesContainer,
  ComponentTitle,
} from "App/styles";
import { MainTitle } from "components/MainTitle";
import YearsCarousel from "components/YearsCarousel";
import { Slideshow, Slide } from "components/Slideshow";
import useEditions from "hooks/useEditions";

import {
  Container,
  Section,
  SectionItem,
  SectionTitle,
  FinalistsGrid,
  FinalistItem,
  FinalistItemHeader,
  FinalistItemBody,
  FinalistItemTitle,
  FinalistItemContent,
  MentionBody,
  GalleryContainer,
  EmptyState,
} from "./styles";

export default function History() {
  const { yearSelected, setYearSelected, winners, mentions, images, loading } =
    useEditions();

  const isEmpty =
    !loading &&
    winners.length === 0 &&
    mentions.length === 0 &&
    (images || []).length === 0;

  return (
    <BodyContainer>
      <MainTitle title="Ediciones" seoTitle="Ediciones" />

      <HeaderSectionEntriesContainer>
        <YearsCarousel
          yearSelected={yearSelected}
          onYearSelected={setYearSelected}
        />
      </HeaderSectionEntriesContainer>

      <Container>
        {isEmpty ? (
          <EmptyState>
            <strong>Edición {yearSelected}</strong>
            <span>
              Todavía no hay finalistas, menciones ni galería publicados para
              este año.
            </span>
          </EmptyState>
        ) : (
          <>
            <Winners items={winners} />
            <Mentions items={mentions} />
            <Gallery images={images} />
          </>
        )}
      </Container>
    </BodyContainer>
  );
}

// Dentro de cada premio el ganador va primero; el resto conserva su orden.
const winnersFirst = (values) =>
  [...values].sort((a, b) => Number(!!b.winner) - Number(!!a.winner));

const Winners = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Section>
      <ComponentTitle>Finalistas</ComponentTitle>
      {items.map((item) => (
        <SectionItem key={item.name}>
          <SectionTitle>{item.name}</SectionTitle>
          <FinalistsGrid>
            {winnersFirst(item.value).map((value) => (
              <FinalistItem key={value.id} winner={value.winner}>
                <FinalistItemHeader winner={value.winner}>
                  {value.winner ? "Ganador" : "Finalista"}
                </FinalistItemHeader>
                <FinalistItemBody>
                  <FinalistItemTitle>Empresa / Institución</FinalistItemTitle>
                  <FinalistItemContent>{value.company}</FinalistItemContent>
                  <FinalistItemTitle>Iniciativa</FinalistItemTitle>
                  <FinalistItemContent>{value.project}</FinalistItemContent>
                </FinalistItemBody>
              </FinalistItem>
            ))}
          </FinalistsGrid>
        </SectionItem>
      ))}
    </Section>
  );
};

const Mentions = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Section>
      <ComponentTitle>Menciones</ComponentTitle>
      {items.map((item) => (
        <SectionItem key={item.id}>
          <SectionTitle>{item.title}</SectionTitle>
          <MentionBody>
            <ReactMarkdown>{item.details}</ReactMarkdown>
          </MentionBody>
        </SectionItem>
      ))}
    </Section>
  );
};

const Gallery = ({ images }) => {
  if ((images || []).length === 0) {
    return null;
  }

  return (
    <Section>
      <ComponentTitle>Galería</ComponentTitle>
      <GalleryContainer>
        <Slideshow
          controls={true}
          autoplay={false}
          velocity="2000"
          interval="5000"
        >
          {images.map((image) => (
            <Slide key={image.name}>
              <img src={image.url} alt={image.name} />
            </Slide>
          ))}
        </Slideshow>
      </GalleryContainer>
    </Section>
  );
};
